<p i18n="Banner on the login page @@bgt.title">Focus on exceptions!</p>
